import React, {useEffect, useRef, useState} from "react";
import {Pie, PieChart, ResponsiveContainer, Sector, Tooltip} from "recharts";
import styles from "../Report/Report.module.css";
import classes from "./ReleaseActivityPage.module.css";

export default function ViewMetricCardResponsesDoughnutChart({title, countData, emptyTitle, emptyCountData, size=210}) {
    const pieRef = useRef();
    const [activeIndex, setActiveIndex] = useState(-1);
    const RADIAN = Math.PI / 180;

    return (
        <>
            {countData.reduce((result, item) => result + item.value, 0) > 0 &&
                <div className={classes.row} style={{justifyContent: "center", position: "relative"}}>
                    <div
                        className={classes.row}
                        style={{position: "absolute", top: "50%", transform: `translateY(-50%)`}}
                    >
                        <span className={classes.metricCardChartLabel}>{title}</span>
                    </div>
                    <PieChart width={size} height={size} onMouseLeave={() => setActiveIndex(-1)}>
                        <Pie
                            ref={pieRef}
                            activeIndex={activeIndex}
                            data={countData}
                            innerRadius={size * 0.75 / 2}
                            outerRadius={size / 2}
                            paddingAngle={2}
                            dataKey="value"
                        >
                        </Pie>
                    </PieChart>
                </div>
            }

            {countData.reduce((result, item) => result + item.value, 0) === 0 &&
                <div className={classes.row} style={{justifyContent: "center", position: "relative"}}>
                    <div
                        className={classes.row}
                        style={{position: "absolute", top: "50%", transform: `translateY(-50%)`}}
                    >
                        <span className={classes.metricCardChartLabel}>
                            {emptyTitle}
                        </span>
                    </div>

                    <PieChart width={size} height={size}>
                        <Pie
                            data={emptyCountData}
                            innerRadius={size * 0.75 / 2}
                            outerRadius={size / 2}
                            paddingAngle={2}
                            dataKey="value"
                        >
                        </Pie>
                    </PieChart>
                </div>
            }
        </>
    );
}